// @ts-nocheck
import $ from "jquery";

let $table = $("div.priority-table");

let $tabellen = $table.find("table.priority-table");
let $filterAnzeige = $table.find(`input[name="filter-anzeigen"]`);
let $filterRows = $table.find("tr.priority-table__filters");
let $filterSelects = $filterRows.find("select");
let $keineTrefferInfos = $table.find("p.validation__label is-invalid");

// Initial den Filter ggf. auswerten.
// da z.B. der Firefox nach einem F5 die bisherige auswahl (Form-Elemente) wieder setzt
setTabellenfilterRow();

$filterAnzeige.on("change", setTabellenfilterRow);
$filterSelects.on("change", function() {
	setTabellenfilter($(this).closest("table.priority-table"));
});

function setTabellenfilterRow() {
	let filterAnzeigen = $(this).prop("checked");

	$filterAnzeige.prop("checked", filterAnzeigen);

	if (filterAnzeigen) {
		$filterRows.show();

		//Falls der Filter eingeblendet wird,
		//die aktuelle Filterauswahl anwenden
		$.each($tabellen, function() {
			setTabellenfilter($(this));
		});
	} else {
		let $tabellenZeilen = $table.find("tbody tr.priority-table__content");

		$filterRows.hide();
		$keineTrefferInfos.hide();
		$tabellenZeilen.show();
	}
}

function setTabellenfilter($tabelle) {
	let normblattTabellenFilterValues = getNormblattTabellenFilterValues($tabelle);
	let tabellenZeilen = $tabelle.find("tbody tr.priority-table__content");
	let tabellenIndex = $tabelle.attr("data-table-number");
	let $keineTrefferInfo = getKeineTrefferInfo(tabellenIndex);

	if (normblattTabellenFilterValues.length > 0) {
		let zeilenGefunden = false;

		$.each(tabellenZeilen, function() {
			if (normblattTabellenFilterBedingungenErfuellt($(this), normblattTabellenFilterValues)) {
				$(this).show();
				zeilenGefunden = true;
			} else {
				$(this).hide();
			}
		});

		if (zeilenGefunden) {
			$keineTrefferInfo.hide();
		} else {
			$keineTrefferInfo.show();
		}
	} else {
		//Falls kein Filter definiert dann sind wieder alle Rows gültig
		$.each(tabellenZeilen, function() {
			$(this).show();
		});
		$keineTrefferInfo.hide();
	}
}

// Ermittelt für die übergebene Tabelle die ausgewählte Filter
function getNormblattTabellenFilterValues(tabelle) {
	let filter = tabelle.find("tr.priority-table__filters select");
	let values = [];

	$.each(filter, function() {
		let id = $(this).attr("id");
		let value = $(this).val();
		// Falls der Filterwert nicht definiert, nicht empty ist und es sich auch nicht um ein geschütztes Leerzeichen handelt
		// dann die Filterwerte setzen (merken)
		if (value != undefined && value != "" && value.charCodeAt(0) != 160) {
			id = id.substr(2, id.length - 2);

			values.push({
				"id": id,
				"value": value
			});
		}
	});

	return values;
}

// Überprüft, ob die Row für alle Filterbedingungen gültig ist
function normblattTabellenFilterBedingungenErfuellt($zeile, normblattTabellenFilterValues) {
	for (let i = 0; i < normblattTabellenFilterValues.length; i++) {
		let normblattTabellenFilterValue = normblattTabellenFilterValues[i];

		if (!normblattTabellenFilterBedingungErfuellt($zeile, normblattTabellenFilterValue)) {
			return false;
		}
	}

	return true;
}

// Überprüft, ob die Row für die übergebene Filterbedingung gültig ist
function normblattTabellenFilterBedingungErfuellt($zeile, normblattTabellenFilterValue) {
	let $zeilenInhalte = $zeile.find(`td[headers="${normblattTabellenFilterValue.id}"]`);

	for (let i = 0; i < $zeilenInhalte.length; i++) {
		let zeilenInhalt = $zeilenInhalte[i];

		if ($(zeilenInhalt).text() == normblattTabellenFilterValue.value) {
			return true;
		}
	}

	return false;
}

function getKeineTrefferInfo(tabellenIndex) {
	return $table.find(`p[data-table-number="${tabellenIndex}"]`);
}
